<template>
    <div id="app" :class="{ 'root': true, [$route.name]: true }">
        <div class='screencontainer'>
            <div class="top-menu-bar">
                <label for="hamburger" class='border-menu'></label>
                <input type="checkbox" id="hamburger" />

                <div class='poolsdropdown'>
                    <button class='simplebutton'>☰</button>
                    <div class='dropdown'>
                        <router-link to="/pools">Pools</router-link>
                        <router-link v-if="!!default_account" :to="`/pools?see=${default_account}`">My
                            dashboard</router-link>
                        <p>____________</p>
                        <button id='myAddress' class='simplebutton margintop' v-show='defaultAccount !== null'>
                            <a :href="'https://etherscan.io/address/' + default_account" rel='noopener noreferrer'> {{
                                defaultAccount }} </a>
                        </button>
                        <button class='simplebutton margintop' @click='changeWallets'>Change wallet</button>
                    </div>
                </div>

                <router-link to="/">Home</router-link>
                <router-link v-show="config.blockchainId === 'ethereum'" to="/pools">Pools</router-link>
                <div v-if="!!config.factoryV2RegistryAddress" class='poolsdropdown'>
                    <span>Factory</span>
                    <div class='dropdown'>
                        <router-link to="/factory/create">Create pool</router-link>
                        <router-link to="/factory/create_gauge"
                            v-if="config.factoryV2CanCreateGauges || config.factoryV2HasGauges">Deploy
                            Gauge</router-link>
                        <router-link to="/factory/create_vote"
                            v-if="config.factoryV2CanCreateGauges || config.factoryV2HasGauges">Create Gauge
                            Vote</router-link>
                    </div>
                </div>
                <a v-show="config.blockchainId === 'ethereum'" href="https://dao.curve.finance">DAO</a>
                <router-link v-show="config.blockchainId === 'ethereum'" to='/usecrv' class='useCRV'>Use <img
                        class='icon small' :src="publicPath + 'logo.png'"> CRV</router-link>
                <router-link v-show="config.blockchainId === 'ethereum'" to="/trade">Trade</router-link>
                <div v-show="config.blockchainId === 'ethereum'" class='poolsdropdown'>
                    <router-link to="/combinedstats">Stats</router-link>
                    <div class='dropdown'>
                        <router-link to="/combinedstats">Stats</router-link>
                        <a href="https://dune.com/mrblock_buidl/Curve.fi" target="_blank" rel="noopener noreferrer">Dune
                            dashboard ↗</a>
                        <a href="https://llama.airforce/#/curve/" target="_blank" rel="noopener noreferrer">Llama
                            Airforce ↗</a>
                    </div>
                </div>

                <router-link to="/risks">Risks</router-link>
                <!-- <router-link to="/careers">Careers</router-link> -->
                <div class='poolsdropdown'>
                    <router-link to="#">Network</router-link>
                    <div class='dropdown'>
                        <a href='https://classic.curve.finance' rel='noopener noreferrer'>Ethereum</a>
                        <a href='https://arbitrum.curve.finance' rel='noopener noreferrer'>Arbitrum</a>
                        <a href='https://aurora.curve.finance' rel='noopener noreferrer'>Aurora</a>
                        <a href='https://avax.curve.finance' rel='noopener noreferrer'>Avalanche</a>
                        <a href='https://ftm.curve.finance' rel='noopener noreferrer'>Fantom</a>
                        <a href='https://harmony.curve.finance' rel='noopener noreferrer'>Harmony</a>
                        <a href='https://optimism.curve.finance' rel='noopener noreferrer'>Optimism</a>
                        <a href='https://polygon.curve.finance' rel='noopener noreferrer'>Polygon</a>
                        <a href='https://xdai.curve.finance' rel='noopener noreferrer'>xDai</a>
                        <a href='https://moonbeam.curve.finance/' rel='noopener noreferrer'>Moonbeam</a>
                        <a href='https://kava.curve.finance/' rel='noopener noreferrer'>Kava</a>
                        <a href='https://celo.curve.finance/' rel='noopener noreferrer'>Celo</a>
                    </div>
                </div>
                <div class='poolsdropdown right'>
                    <span>?</span>
                    <div class='dropdown'>
                        <router-link to='/whitepaper'>Whitepaper</router-link>
                        <router-link to="/audits">Audits</router-link>
                        <router-link to="/events">Events</router-link>
                        <router-link to="/contracts">Contracts</router-link>
                        <router-link to="/bugbounty">Bug Bounty</router-link>
                        <router-link to="/rootfaq">FAQ</router-link>
                        <router-link to="/integrations">Integrations</router-link>
                        <router-link to="/devdocs">Developer Docs</router-link>

                        <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
                        <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
                        <p>____________</p>
                        <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
                        <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
                        <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
                        <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
                        <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
                        <a href="https://llama.airforce/#/curve/" rel='noopener noreferrer'>Llama Airforce</a>
                        <p>____________</p>
                        <a href="https://github.com/curvefi/curve-contract">git@</a>
                    </div>
                </div>
                <a href="https://dao.curve.finance" class='showmobile'>DAO</a>
                <router-link to='/usecrv' class='showmobile'>Use CRV</router-link>
                <router-link to="/combinedstats" class='showmobile'>Stats</router-link>
                <router-link to='/whitepaper' class='showmobile'>Whitepaper</router-link>
                <router-link to="/audits" class='showmobile'>Audits</router-link>
                <router-link to="/events" class='showmobile'>Events</router-link>
                <router-link to="/bugbounty" class='showmobile'>Bug Bounty</router-link>
                <router-link to="/rootfaq" class='showmobile'>FAQ</router-link>
                <router-link to="/integrations" class='showmobile'>Integrations</router-link>
                <router-link to="/devdocs" class='showmobile'>Developer Docs</router-link>
                <a href='https://news.curve.finance' rel='noopener noreferrer' class='showmobile'>News</a>
                <a href='https://resources.curve.finance' rel='noopener noreferrer' class='showmobile'>Resources</a>
                <a href="https://twitter.com/CurveFinance" class='showmobile' rel='noopener noreferrer'>#Twitter</a>
                <a href="https://t.me/curvefi" class='showmobile' rel='noopener noreferrer'>@Telegram</a>
                <a href="https://discord.gg/9uEHakc" class='showmobile' rel='noopener noreferrer'>@Discord</a>
                <a href="https://dune.xyz/mrblock_buidl/Curve.fi" class='showmobile' rel='noopener noreferrer'>Dune
                    Analytics</a>
                <a href="https://github.com/curvefi/curve-contract" class='showmobile'>git@</a>
                <button class='simplebutton showmobile' @click='changeWallets'>Change wallet</button>
            </div>
            <div id="screen">
                <div :class="'blue window ' + $route.name">
                    <h1><img :src="logoSrc" alt="🌀 Curve"></h1>
                </div>
                <HighGasWarning />
                <CoingeckoIncidentNotice />
                <HarmonyNotice />
                <div class='simple-error window' v-show='networkIdError'>
                    {{ networkIdError }}
                    <span v-show="config.walletGuideUrl && !showChangeNetworkButton">
                        <a :href="config.walletGuideUrl" target="_blank" rel="noopener noreferrer">Follow this guide to
                            connect to the right network!</a>
                    </span>
                    <button @click='changeNetwork' v-show='showChangeNetworkButton'>Connect to the {{ config.name }}
                        network</button>
                </div>
                <div class='simple-error window' v-show='!networkIdError && networkDelayError'>
                    {{ networkDelayError }}
                    </span>
                </div>
                <div class='info-message gentle-message window half-width gentle-message'
                    v-if='!networkIdError && hasConnectedWallet'>
                    You haven't connected a wallet. <button @click='changeWallets'>Connect wallet</button>
                </div>
                <div class='simple-error window' v-show='plsReturn'>
                    Your recent withdrawal from Curve resulted in getting 1000 more USDT because of another user
                    mistakenly transferring funds to the contract.
                    If you wish to return them - please contact us on <a
                        href='https://twitter.com/CurveFinance'>Twitter</a>/<a
                        href='https://t.me/curvefi'>Telegram</a>/<a href="https://discord.gg/9uEHakc"
                        rel='noopener noreferrer'>@Discord</a>. Thank you!
                </div>
                <div class='simple-error window' v-show='plsReturn2'>
                    Your recently made a huge arb in USDK pool where someone incurred a huge loss.
                    If you wish to return partially - please contract us on
                    <a href='https://twitter.com/CurveFinance'>Twitter</a>/<a
                        href='https://t.me/curvefi'>Telegram</a>/<a href="https://discord.gg/9uEHakc"
                        rel='noopener noreferrer'>@Discord</a>. Thank you!
                </div>
                <router-view />
            </div>
        </div>
        <footer>
            <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
            <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
            <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
            <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
            <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
            <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
            <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
            <a href="https://github.com/curvefi/curve-contract">git@</a>
            <router-link to="/devdocs">Developer Docs</router-link>
            <router-link to="/careers">Careers</router-link>

        </footer>
    </div>
</template>

<script>
import config from '@/constants/config'
import { getters, contract as currentContract, changeContract, poolMenu } from '../../contract'
import init, { onboard, changeWallets, changeNetwork, canAutomaticallyChangeNetwork } from '../../init'
import pools from '@/constants/pools'
import HighGasWarning from '@/components/common/HighGasWarning.vue'
import CoingeckoIncidentNotice from '@/components/common/CoingeckoIncidentNotice.vue'
import HarmonyNotice from '@/components/common/HarmonyNotice.vue'

export default {
    metaInfo: {
        title: 'Curve.finance',
        meta: [
            { 'property': 'og:title', 'content': 'curve.finance' },
            { 'property': 'og:url', 'content': 'https://classic.curve.finance' },
            { 'property': 'og:type', 'content': 'website' },
            { 'property': 'og:description', 'content': 'Curve is an exchange liquidity pool on Ethereum designed for extremely efficient stablecoin trading' },
            { 'property': 'og:image', 'content': '/curve.png' },
            { 'name': 'twitter:card', 'content': 'summary_large_image' },
            { 'name': 'twitter:title', 'content': 'curve.finance' },
            { 'name': 'twitter:site', 'content': '@CurveFinance' },
            { 'name': 'twitter:creator', 'content': '@CurveFinance' },
            { 'name': 'twitter:description', 'content': 'Curve is an exchange liquidity pool on Ethereum designed for extremely efficient stablecoin trading' },
            { 'name': 'twitter:url', 'content': 'https://classic.curve.finance' },
            { 'name': 'twitter:image', 'content': '/curve.png' },
        ]
    },
    components: {
        HighGasWarning,
        CoingeckoIncidentNotice,
        HarmonyNotice,
    },
    data: () => ({
        pools,
        config,
        showChangeNetworkButton: false,
    }),
    computed: {
        ...getters,
        poolMenu() {
            return poolMenu;
        },
        publicPath() {
            return process.env.BASE_URL
        },
        logoSrc() {
            // if(!currentContract.swapbtc && currentContract.currentContract != 'linkusd') return this.publicPath + config.logoPath
            // else return this.publicPath + 'logo_ren_beta_optimized.svg'
            return this.publicPath + config.logoPath
        },
        hasConnectedWallet() {
            return this.default_account == '0x0000000000000000000000000000000000000000'
                && !['Donate', 'StatsDaily', 'Audits', 'Stats', 'Contracts', 'FAQ', 'RootFAQ'].includes(this.$route.name)
        },
        networkIdError() {
            // Asynchronously update a reactive property after running feature detection for
            // automatically changing network
            Promise.resolve(currentContract.networkIdError ? canAutomaticallyChangeNetwork() : false)
                .then((showChangeNetworkButton) => {
                    this.showChangeNetworkButton = showChangeNetworkButton;
                });

            return currentContract.networkIdError;
        },
        networkDelayError() {
            return currentContract.networkDelayError;
        },
        plsReturn() {
            return currentContract.currentContract.toLowerCase() == '0x72c20f89008729c91b6bb85f3104fda942494cef'.toLowerCase()
        },
        plsReturn2() {
            return currentContract.currentContract.toLowerCase() == '0xB2398330970C7cAd95535D076BA3f64Cc6aFd43d'.toLowerCase()
        },
        defaultAccount() {
            if (!this.default_account || this.default_account == '0x0000000000000000000000000000000000000000') return null
            return this.default_account.slice(0, 6) + '...' + this.default_account.slice(-6)
        },
    },
    methods: {
        changePools(pool) {
            changeContract(pool)
        },
        async changeWallets() {
            changeWallets()
        },
        changeNetwork,
    },
}
</script>

<style scoped>
.margintop {
    margin-top: 0.3em;
}

#myAddress a {
    display: inline;
    margin: 0;
    padding: 0;
    color: white;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 730px) {
    .top-menu-bar>.poolsdropdown {
        display: none;
    }

    .blue.window.half-width,
    .info-message.window.half-width {
        width: 90%;
    }
}

h1>img {
    height: 52.125px;
}

.simple-error.window {
    box-shadow: none;
}

.blue.window.Events+.info-message.gentle-message {
    width: 730px;
    max-width: 730px;
}

.blue.window.Trade+.info-message.gentle-message {
    width: 1000px;
    max-width: 1000px;
}

.simple-error a:hover,
.simple-error a:visited,
.CRV a:hover,
.CRV a:visited {
    color: white;
}

.useCRV img {
    vertical-align: middle;
}

.dropdown {
    z-index: 3;
}
</style>
